import type { Ref } from "@nabla/api";
import { shellCopy } from "../copy.ts";
import { Link } from "./Link.tsx";
import styles from "./Header.module.css";
import { classes, quietLink } from "../../design/classes.ts";

export function Breadcrumbs({ path, title }: { readonly path: readonly Ref[]; readonly title: string }) {
  return (
    <nav className={styles.crumbs} aria-label={shellCopy.navegacao.ondeVoceEsta}>
      <ol className={styles.trail}>
        {path.map((ref, index) => (
          <li key={ref.href} className={index === path.length - 1 ? styles.parent : styles.crumb}>
            <Link href={ref.href} kind="zoom-out" className={classes(styles.crumbLink, quietLink)}>
              {ref.name}
            </Link>
          </li>
        ))}
        <li className={styles.here} aria-current="page">
          {title}
        </li>
      </ol>
    </nav>
  );
}
